//PAQUETERIAS
import { useEffect, useState, useMemo, useRef } from "react";
import { CustomDialog } from "react-st-modal";
import NotificationSystem from 'react-notification-system';
import MODAL_TABLE from "../../main_components/modal/modal_Table";
//COMPONENTES
import AlertResponse from "../../main_components/alerts/alertResponse";
//ESTILOS
import "../../components_cfdi/estilo.css";
import "../../components_cfdi/modal.css";
import "./catalogexpense.css";
//IMAGENES/ICONOS
import { refresh_token } from "../../main_components/tokens/tokenrefresh";
import { BREADCRUMBS } from "../../main_components/pagination/breadcrumbs";
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import RENDER_TOOLBAR_INTERNAL_ACTIONS from "../../main_components/methods_v2/export";
import RENDER_ROW_ACTION_MENU_ITEMS from "./tools/render_row_action_menuItems";
import OPERATIONS_EXPENSE_CONCEPT from "./tools/op_expense_concept";
import CREATE from "../../imgComponents/create.png";
import { update_null_identifiers } from "../../main_components/methods_v2/auxiliar_funtion";

import { findInObjectDisplayRole } from "../../Content/verify_role";
import { expenses_concept_get } from "../../services/expenses/concept";

const CATALOG_EXPENSE_CONCEPT_V2 = () => {

  const notificationSystemRef = useRef();
  const [data, setData] = useState([]);
  const [modalT, setmodalT] = useState(false);
  const [menssage, setmenssage] = useState("");
  const [modalGeneral, setmodalGeneral] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [rowSelection, setRowSelection] = useState({});
  const [total_rows, settotal_rows] = useState("");
  const [query_filters, setquery_filters] = useState({});
  const [query_filters_dt, setquery_filters_data] = useState("");



  const update_identifiers =
    [
      { catalog_name: 'string' },
      { enable: 'string' },
      { name_role: 'String' },
      { date_register: 'string' }
    ];



  const handleStateChange = (newState) => {
    const filteredRowsCount = newState.filteredRowModel
    settotal_rows(filteredRowsCount);
  };

  function alertas(msj, status) {

    if (status === true) {
      notificationSystemRef.current.addNotification({
        message: <AlertResponse msj={msj} view={true}></AlertResponse>,
        level: 'success',
        position: 'br',
        autoDismiss: 10,
      });
    } else {
      notificationSystemRef.current.addNotification({
        message: <AlertResponse msj={msj} view={false}></AlertResponse>,
        level: 'error',
        position: 'br',
        autoDismiss: 60,
      });
    }
  }

  const handleSubmit = async (query_filters_flag, query_filters_data) => {

    setmodalT(true);
    setData([]);
    setIsLoading(true);

    try {
      var rf_token = await refresh_token();
      if (rf_token === true) {
        setTimeout(async () => {
          try {
            if (query_filters_flag) {
              const d = await expenses_concept_get();
              setquery_filters(query_filters_data);
            } else {
              const d = await expenses_concept_get();
              const data = d.data;
              var ndt = update_null_identifiers(data, update_identifiers);
              setData(ndt);
              setmodalT(false);
              setIsLoading(false);
            }
          } catch (err) {
            console.log("error", err);
            setData([]);
            setmodalT(false);
            setIsLoading(false);
          }
        }, 1000);
      } else { }
    } catch (err) {
      console.log(err);
    }
  };

  const columns = useMemo(
    () => [
      {
        id: "catalog_name",
        header: "Concepto",
        accessorKey: "catalog_name",
        size: 300,
      },
      {
        id: "enable",
        header: "Estado",
        filterVariant: 'select',
        accessorKey: "enable",
        accessorFn: (d) => {
          return d.enable === true ? "Habilitado" : "Deshabilitado";
        },
        size: 200
      },
      {
        id: "name_role",
        header: "Rol Asignado",
        accessorKey: "name_role",
        size: 300,
      },
      {
        id: "date_register",
        header: "Fecha Registrada",
        accessorKey: "date_register",
        size: 200
      }
    ],
    []
  );





  const handle_success_filter = (a, b) => {
    handleSubmit(a, b);
    notificationSystemRef.current.addNotification({
      message: <AlertResponse msj={"Filtro Aplicado"} view={true}></AlertResponse>,
      level: "success",
      position: "br",
      autoDismiss: 10,
    });
  }

  useEffect(() => {
    if (total_rows === "") {
    } else {
      const getCurrentPath = () => {
        const search = window.location.search;
        const pathWithoutQuestionMark = search.startsWith('?') ? search.slice(1) : search;
        return pathWithoutQuestionMark;
      };

      const pathWithoutQuestionMark = getCurrentPath();
      setquery_filters_data(pathWithoutQuestionMark)
    }
  }, [total_rows])



  return (
    <>
      <BREADCRUMBS niveles={
        [
          { label: "CATÁLOGO DE CONCEPTOS", path: null },
        ]
      }
        cards_dashboard={true}
        total_rows={total_rows !== "" ? total_rows : 0}
        filter_row={total_rows !== "" ? total_rows?.getFilteredRowModel()?.rows?.length : 0}
        visibility_row={total_rows !== "" ? total_rows?.getPaginationRowModel()?.rows?.length : 0}
        total={data?.length}
      ></BREADCRUMBS>
      <div className="new_table_v2">

        <NotificationSystem ref={notificationSystemRef} ></NotificationSystem>
        <MODAL_TABLE
          open={true}
          message={menssage}
          modalGeneral={modalGeneral}
          modalT={modalT}
        ></MODAL_TABLE>
        <div >
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGrouping
            enablePinning
            onStateChange={handleStateChange}
            enableFacetedValues
            enableStickyHeader
            enableStickyFooter
            enableRowPinning
            enableColumnFilterModes
            enableRowSelection
            getRowId={(row) => row?.id}
            onRowSelectionChange={setRowSelection}
            enableTooltips={false}
            localization={MRT_Localization_ES}
            state={{ rowSelection, isLoading: isLoading }}
            enableColumnResizing
            enableColumnPinning
            enableRowActions={findInObjectDisplayRole(["PU:EC1", "PU:EC2", "PU:EC3"]) === "none" ? false : true}
            enableColumnOrdering
            enableExpandAll={false}
            enableColumnDragging={false}
            initialState={{ showGlobalFilter: true, showColumnFilters: true }}
            muiCircularProgressProps={{ color: 'secondary', thickness: 5, size: 55 }}
            muiSkeletonProps={{ animation: 'pulse', height: 28 }}
            rowVirtualizerInstanceRef
            rowVirtualizerOptions={{ overscan: 5 }}
            columnVirtualizerOptions={{ overscan: 2 }}
            muiTableContainerProps={{ sx: { maxHeight: '69vh', '@media (max-height: 810px)': { maxHeight: '65vh' } } }}
            positionToolbarAlertBanner="bottom"
            paginationDisplayMode='pages'
            rowPinningDisplayMode='sticky'
            layoutMode="grid"
            muiTableHeadCellProps={{ sx: { flex: '0 0 auto', whiteSpace: "normal !important" } }}
            muiTableBodyCellProps={{ sx: { flex: '0 0 auto', whiteSpace: "normal !important" } }}
            muiPaginationProps={{ color: 'primary', shape: 'rounded', variant: 'variant', }}
            displayColumnDefOptions={{
              'mrt-row-pin': {
                Header: () => (
                  <div>
                    <img
                      title="Registrar Catálogo de Conceptos"
                      src={CREATE}
                      style={{ "cursor": "pointer", display: findInObjectDisplayRole(["PU:EC2", "PU:EC3"]) }}
                      onClick={async () => {
                        const result = await CustomDialog(
                          <OPERATIONS_EXPENSE_CONCEPT
                            operation={"CREATE"}
                            handleSubmit={handleSubmit}
                            alertas={alertas}
                            setmodalT={setmodalT}
                          />,
                          {
                            className: "custom-modal-3",
                            title: "Registrar Catálogo de Conceptos",
                            showCloseIcon: true,
                            isCanClose: false,
                          }
                        );
                      }}
                    ></img>
                  </div>
                ),
                enableHiding: true,
              },
              'mrt-row-actions': {
                enableHiding: true,
              },
              'mrt-row-expand': {
                enableHiding: true,
              },
              'mrt-row-select': {
                enableHiding: true,
              }
            }}
            muiTableBodyRowDragHandleProps={({ table }) => ({
              onDragEnd: () => {
                const { draggingRow, hoveredRow } = table.getState();
                if (hoveredRow && draggingRow) {
                  data.splice(
                    hoveredRow.index,
                    0,
                    data.splice(draggingRow.index, 1)[0],
                  );
                  setData([...data]);
                }
              },
            })}
            muiTableBodyRowProps={
              ({ row, table }) => {
                settotal_rows(table);
                const { density } = table.getState();
                return {
                  sx: {
                    height: row.getIsPinned()
                      ? `${density === 'compact' ? 30 : density === 'comfortable' ? 35 : 69
                      }px`
                      : undefined,
                  },
                };
              }
            }
            renderRowActionMenuItems={({ row, closeMenu }) => [
              <RENDER_ROW_ACTION_MENU_ITEMS
                closeMenu={closeMenu}
                setmodalT={setmodalT}
                setmenssage={setmenssage}
                setmodalGeneral={setmodalGeneral}
                row={row}
                handleSubmit={handleSubmit}
                refresh_token={refresh_token}
                alertas={alertas}
              />
            ]}

            renderToolbarInternalActions={({ table, index }) => (
              <RENDER_TOOLBAR_INTERNAL_ACTIONS
                table={table}
                file_name={"Consultar Catálogo de Conceptos"}
                update_identifiers={update_identifiers}
                settotal_rows={settotal_rows}
                query_filters={query_filters}
                query_filters_dt={query_filters_dt}
                handle_get_consult={handleSubmit}
                key={index}
                handle_success_filter={handle_success_filter}
                share_filter={true}
                total_rows={total_rows !== "" ? total_rows : 0}
              />
            )
            }
          />

        </div>

      </div>
    </>
  );
}

export default CATALOG_EXPENSE_CONCEPT_V2;
